import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form';

import {
    REQUEST_WAREHOUSES,
    FETCH_WAREHOUSES_SUCCESS,
    FETCH_WAREHOUSES_FAILURE,
    RESET_WAREHOUSES,
    SELECT_WAREHOUSE,
    RESET_CURRENT_WAREHOUSE,
    REQUEST_WAREHOUSE_DETAIL,
    FETCH_WAREHOUSE_DETAIL_SUCCESS,
    FETCH_WAREHOUSE_DETAIL_FAILURE,
    REQUEST_CREATING_WAREHOUSE,
    CREATE_WAREHOUSE_SUCCESS,
    CREATE_WAREHOUSE_FAILURE,
    REQUEST_EDITING_WAREHOUSE,
    EDIT_WAREHOUSE_SUCCESS,
    EDIT_WAREHOUSE_FAILURE,
    REQUEST_WAREHOUSE_SALES_ORDERS,
    FETCH_WAREHOUSE_SALES_ORDERS_SUCCESS,
    FETCH_WAREHOUSE_SALES_ORDERS_FAILURE,
    REQUEST_WAREHOUSE_PURCHASE_ORDERS,
    FETCH_WAREHOUSE_PURCHASE_ORDERS_SUCCESS,
    FETCH_WAREHOUSE_PURCHASE_ORDERS_FAILURE,
    REQUEST_WAREHOUSE_BINS,
    FETCH_WAREHOUSE_BINS_SUCCESS,
    FETCH_WAREHOUSE_BINS_FAILURE,
    REQUEST_DELETE_WAREHOUSE,
    DELETE_WAREHOUSE_SUCCESS,
    DELETE_WAREHOUSE_FAILURE,
} from './type';

import {
    WAREHOUSES_URL,
    DASHBOARD_URL
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';
// Warehouses Actions

export function fetchWarehouses() {
    return dispatch => {
        dispatch({ type: REQUEST_WAREHOUSES });
        return axios.get(WAREHOUSES_URL,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchWarehousesSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchWarehousesFailure(err));
            });
    }
}

export function searchWarehouses(name) {
    return dispatch => {
        dispatch({ type: REQUEST_WAREHOUSES });
        return axios.get(WAREHOUSES_URL + "?Name=" + name,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchWarehousesSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchWarehousesFailure(err));
            });
    }
}

export function fetchWarehousesSuccess(warehouses) {
    return {
        type: FETCH_WAREHOUSES_SUCCESS,
        payload: warehouses
    };
}

export function fetchWarehousesFailure(error) {
    return {
        type: FETCH_WAREHOUSES_FAILURE,
        payload: error
    };
}

export function selectWarehouse(warehouse) {
    return {
        type: SELECT_WAREHOUSE,
        payload: warehouse
    };
}

export function resetCurrentWarehouse() {
    return {
        type: RESET_CURRENT_WAREHOUSE
    }
}

export function resetWarehouses() {
    return {
        type: RESET_WAREHOUSES,
    };
}


export function fetchWarehouseDetail(warehouse_id) {
    return dispatch => {
        dispatch({ type: REQUEST_WAREHOUSE_DETAIL });
        return axios.get(WAREHOUSES_URL + warehouse_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchWarehouseDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchWarehouseDetailFailure(err));
            });
    }
}

export function fetchWarehouseDetailSuccess(warehouseDetail) {
    return {
        type: FETCH_WAREHOUSE_DETAIL_SUCCESS,
        payload: warehouseDetail
    };
}

export function fetchWarehouseDetailFailure(error) {
    return {
        type: FETCH_WAREHOUSE_DETAIL_FAILURE,
        payload: error
    };
}


export function createWarehouse({
    Name,
    Street,
    City,
    State,
    Zip,
    Latitude,
    Longitude,
    FirstName,
    LastName,
    Telephone,
    Cellphone,
    Fax,
    Email,
}) {
    return dispatch => {
        dispatch({ type: REQUEST_CREATING_WAREHOUSE });
        axios.post(WAREHOUSES_URL,
            {
                Name,
                Street,
                City,
                State,
                Zip,
                Latitude,
                Longitude,
                FirstName,
                LastName,
                Telephone,
                Cellphone,
                Fax,
                Email,
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(createWarehouseSuccess());
              browserHistory.push('/warehouses');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(createWarehouseFailure(err));
            });
    }
}

export function createWarehouseSuccess() {
    return {
        type: CREATE_WAREHOUSE_SUCCESS
    }
}

export function createWarehouseFailure(error) {
    return {
        type: CREATE_WAREHOUSE_FAILURE,
        payload: error
    }
}

export function editWarehouse({
    Warehouse_id,
    Name,
    Street,
    City,
    State,
    Zip,
    Latitude,
    Longitude,
    FirstName,
    LastName,
    Telephone,
    Cellphone,
    Fax,
    Email,
}) {
    return dispatch => {
        dispatch({ type: REQUEST_EDITING_WAREHOUSE });
        axios.put((WAREHOUSES_URL + Warehouse_id),
            {
                Name,
                Street,
                City,
                State,
                Zip,
                Latitude,
                Longitude,
                FirstName,
                LastName,
                Telephone,
                Cellphone,
                Fax,
                Email,
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editWarehouseSuccess());
              browserHistory.push('/warehouses'); // If editd succesfully, refresh the paymentTerm page.
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(editWarehouseFailure(err));
            });
    }
}
export function editWarehouseDefault(
    Warehouse_id,
    IsDefault
) {
    return dispatch => {
        dispatch({ type: REQUEST_EDITING_WAREHOUSE });
        axios.put((WAREHOUSES_URL + Warehouse_id),
            {
              IsDefault
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editWarehouseSuccessDefault(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(editWarehouseFailure(err));
            });
    }
}

export function editWarehouseSuccess() {
    return {
        type: EDIT_WAREHOUSE_SUCCESS
    }
}

export function editWarehouseSuccessDefault(response) {
    return {
        type: EDIT_WAREHOUSE_SUCCESS,
        payload: response
    }
}

export function editWarehouseFailure(error) {
    return {
        type: EDIT_WAREHOUSE_FAILURE,
        payload: error
    }
}

export function fetchWarehouseSalesOrders(Warehouse_id) {
  return dispatch => {
      dispatch({ type: REQUEST_WAREHOUSE_SALES_ORDERS });
      return axios.get(DASHBOARD_URL + "warehouse/sales/" + Warehouse_id,
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(fetchWarehouseSalesOrdersSuccess(response));
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            dispatch(fetchWarehouseSalesOrdersFailure(err));
          });
  }
}

export function fetchWarehouseSalesOrdersSuccess(salesOrders) {
    return {
        type: FETCH_WAREHOUSE_SALES_ORDERS_SUCCESS,
        payload: salesOrders
    }
}

export function fetchWarehouseSalesOrdersFailure(error) {
    return {
        type: FETCH_WAREHOUSE_SALES_ORDERS_FAILURE,
        payload: error
    }
}

export function fetchWarehousePurchaseOrders(Warehouse_id) {
  return dispatch => {
      dispatch({ type: REQUEST_WAREHOUSE_PURCHASE_ORDERS });
      return axios.get(DASHBOARD_URL + "warehouse/purchase/" + Warehouse_id,
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(fetchWarehousePurchaseOrdersSuccess(response));
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            dispatch(fetchWarehousePurchaseOrdersFailure(err));
          });
  }
}

export function fetchWarehousePurchaseOrdersSuccess(purchaseOrders) {
    return {
        type: FETCH_WAREHOUSE_PURCHASE_ORDERS_SUCCESS,
        payload: purchaseOrders
    }
}

export function fetchWarehousePurchaseOrdersFailure(error) {
    return {
        type: FETCH_WAREHOUSE_PURCHASE_ORDERS_FAILURE,
        payload: error
    }
}

export function fetchWarehouseBins(Warehouse_id) {
    return dispatch => {
        dispatch({ type: REQUEST_WAREHOUSE_BINS });
        return axios.get(WAREHOUSES_URL + Warehouse_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchWarehouseBinsSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchWarehouseBinsFailure(err));
            });
    }
}

export function fetchWarehouseBinsSuccess(WarehouseInformation) {
    return {
        type: FETCH_WAREHOUSE_BINS_SUCCESS,
        payload: WarehouseInformation
    }
}

export function fetchWarehouseBinsFailure(error) {
    return {
        type: FETCH_WAREHOUSE_BINS_FAILURE,
        payload: error
    }
}

export function deleteWarehouse(id) {
  return dispatch => {
      dispatch({ type: REQUEST_DELETE_WAREHOUSE });
      axios.delete(WAREHOUSES_URL + id,
        {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        }
      )
        .then(response => {
          dispatch(deleteWarehouseSuccess());
          dispatch(fetchWarehouses());
        }, err => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          dispatch(deleteWarehouseFailure(err));
        });
  }
}

export function deleteWarehouseSuccess() {
    return {
        type: DELETE_WAREHOUSE_SUCCESS,
    }
}

export function deleteWarehouseFailure(error) {
    return {
        type: DELETE_WAREHOUSE_FAILURE,
        payload: error
    }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/warehouses_actions.js